<!-- Digital Twin City Infrastructure Platform Introduction -->
<template>
  <div class="dtwin-city-intro">
    <div class="dtwin-city-intro-wrapper">
      <header
        class="dtwin-city-intro-hd"
        v-scroll-animate="{
          animation: 'fadeInUp',
        }"
      >
        <!-- Digital Twin City Infrastructure Platform Introduction -->
        {{ tittle }}
      </header>
      <article class="dtwin-city-intro-bd">
        <p
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 100,
            duration: 800,
          }"
        >
          数字孪生城市基础平台是通过将城市的物理实体、数据和模型融合在一起，实现对城市的实时仿真、监测和管理的管理平台。能力包括数据集成和管理、仿真和模型、可视化和交互、数据分析和决策支持、实时监测和预警、可持续发展和优化等。可为城市决策者、规划者和市民提供全面的城市信息和决策支持，帮助实现更智能、高效和可持续的城市发展。
        </p>
      </article>
      <footer
        class="dtwin-city-intro-ft"
        v-scroll-animate="{
          animation: 'fadeInUp',
          delay: 400,
          duration: 600,
        }"
      >
        <aside class="intro-ft-aside">
          <img
            src="@/assets/images/dtwin/twin-city-1.png"
            class="aside-img"
            alt=""
          />
        </aside>
        <article class="intro-ft-main">
          <img
            src="@/assets/images/dtwin/twin-city-2.png"
            class="main-img"
            alt=""
          />
          <img
            src="@/assets/images/dtwin/twin-city-3.png"
            class="main-img"
            alt=""
          />
        </article>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {
      tittle: "数字孪生城市基础平台",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.dtwin-city-intro {
  padding: 64px 0;
  background: #fff;
  .dtwin-city-intro-wrapper {
    width: 1200px;
    margin: 0 auto;
  }

  .dtwin-city-intro-hd {
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 32px;
    color: #333;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .dtwin-city-intro-bd {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 18px;
    color: #1d1d1f;
    line-height: 32px;
    text-align: justify;
    font-style: normal;
    text-indent: 2em;
    .intro-item {
      padding-left: 20px;
    }
    .intro-extra {
    }
  }
  .dtwin-city-intro-ft {
    display: flex;
    height: 440px;
    .intro-ft-aside {
      width: 782px;
      margin-right: 12px;
    }
    .intro-ft-main {
      flex: 1;
    }
    .aside-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .main-img {
      width: 404px;
      height: 212px;
      object-fit: cover;
      box-sizing: border-box;

      &:first-child {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
